import React from 'react';

import { VisuallyHidden } from '@rbilabs/components-library/build/components/visually-hidden';
import { useIntl } from 'react-intl';

import { ICartEntry } from '@rbi-ctg/menu';
import { IconAdd } from 'components/icons/add-icon';
import { useAddToCartRecentItem } from 'hooks/use-add-to-cart-recent-item';
import { CustomEventNames } from 'state/cdp/constants';

import { IconButton, fill } from './styled';

interface AddToCartProps {
  disabled: boolean;
  cartEntry: ICartEntry;
  event?: CustomEventNames;
  userLocation?: string;
}

export const AddToCart: React.FC<AddToCartProps> = ({
  disabled,
  cartEntry,
  event,
  userLocation,
}) => {
  const { formatMessage } = useIntl();
  const { addToCart, SwitchCartMethodDialog } = useAddToCartRecentItem({
    cartEntry,
    event,
    userLocation,
  });

  return (
    <IconButton disabled={disabled} data-testid="add-to-cart" onClick={addToCart}>
      <VisuallyHidden>{formatMessage({ id: 'addToCart' })}</VisuallyHidden>
      <IconAdd fill={fill} />
      <SwitchCartMethodDialog />
    </IconButton>
  );
};
